<template>
  <transition name="el-zoom-in-center">
    <el-card v-show="add.addshow" class="box-card" style="text-align: left;">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="form" label-width="110px" :rules="rules">
        <el-row>
          <el-col :span="18" :offset="6">
            <el-form-item label="图片说明" prop="column_title">
              <el-input v-model.trim="form.column_title" style="width:200px" />
            </el-form-item>
            <el-form-item label="图片地址" >
              <Single-Image ref="mychild" :uploadimg="uploadimg" />
              <!-- <el-input v-model.trim="form.column_value" style="width:200px" /> -->
            </el-form-item>
            <el-form-item label="启用/禁用" prop="status">
              <el-switch
                v-model="form.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="0"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <template>
                <el-input-number v-model="form.sort" controls-position="right" :min="0" :max="1000"></el-input-number>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <br />
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="resetForm('form')">重置</el-button>
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import PanThumb from "@/components/PanThumb";
import { productlist, productextendadd } from "@/api/base";
import { departtree, findByParentCode } from "@/api/orgin";
import { findwarehouse, addwarehouse } from "@/api/query";
import SingleImage from "@/components/Upload/SingleImage";
import { getToken } from '@/utils/auth'
export default {
  components: { SingleImage, PanThumb },
  props: {
    search: {
      type: Function,
      default: null,
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null,
        };
      },
    },
  },
  data() {
    return {
      uploadimg: {
        uploadurl:
          process.env.VUE_APP_BASE_API +
        "/api/produce/fileuploader/uploadimg",
        resimg: null,
        uploaddata:{ folder: "xyq" },
        headers:{Token:getToken()}
      },
      // 基础数据
      show: true,
      departtree: null, // 掉接口返回部门树
      elselectProps: {
        children: "listSubWareHouses",
        label: "depart_name",
        value: "depart_code",
        id: "depart_uuid",
        checkStrictly: true,
      },
      province: [],
      city: [],
      district: [],
      fromWarehouse: [],
      form: {
        product_code: null,
        column_title: null,
        column_value: null,
        status: 0,
        sort: null,
      },
      rules: {
        column_title: [
          { required: true, message: "请输入图片说明", trigger: "blur" },
        ],
        column_value: [
          { required: true, message: "请输入说明", trigger: "blur" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    // 保存提交
    submitadd(formName) {
      this.$refs[formName].validate((valid) => {
        // 基础表单验证
        if (valid) {
          productextendadd({
            product_code: "mtytyycommhomeslideshow",
            column_title: this.form.column_title,
            column_value: this.uploadimg.resimg,
            status: this.form.status,
            sort: this.form.sort,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "添加成功!",
              });
              this.search();
              this.add.addshow = false;
              this.resetForm(formName);
            } else {
              this.$message({
                type: "warning",
                message: "添加失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.cityId = "";
      this.form.districtId = "";
      this.$refs.mychild.$refs.upload.clearFiles();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
